import { useT } from "@/i18n";
import { IconSearch } from "@/ui";

import { LeagueContextSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";

export type LeagueContextSearchItemViewProps = {
  item: LeagueContextSearchItem;
};

export const LeagueContextSearchItemView = ({ item }: LeagueContextSearchItemViewProps) => {
  const t = useT();

  return (
    <div className="flex min-w-0 items-center gap-3 w-full">
      <IconSearch size="sm" className="shrink-0 text-content-tertiary" aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate">{item.title ?? t("general.text.untitled")}</span>
      <GlobalSearchItemTypeChip type={item.type} />
    </div>
  );
};
